import apiFetch from '../apiFetch'

export default function (token) {
  return apiFetch({endPoint: `Analisis/obtenerCodigoAnalisis`, method: 'GET', body: null, token: token})
}